import React, {Component} from 'react'

import Popup from '../Popup/index';
import Registry from '../../../registry/index';
import BecomeXXLPopup from '../BecomeXXLPopup/index';

import {
    USER_SORTING_SELECT,
    USER_SORT_ALPHA,
    USER_SORT_GENDER,
    USER_SORT_WATCHING,
    USER_SORT_FOLLOWEES,
    USER_SORT_STATUS,
} from '../../../constants/users';

import {
    SIDEBAR_HIDE_ALL
} from '../../../constants/sidebars';

import {
    STREAM_LIMIT_MOBILE,
    STREAM_LIMIT_TABLET,
    STREAM_LIMIT_DESKTOP
} from '../../../constants/streaming';

import {openVideoWindow} from '../../../actions/streaming';

class UserListSortPopup extends Popup {
    constructor(props) {
        super(props);

        this.position = function () {
            if (!this.$anchor || this.$anchor.length === 0) return;

            var offset = this.$anchor.offset(),
                    width = this.$popup.width(),
                    anchorHeight = this.$anchor.height();

            this.$popup.css({
                left: (offset.left - width - 23) + "px",
                top: (offset.top + anchorHeight + 20) + "px"
            });
        };

        this._setSort = this._setSort.bind(this);
        this.onWatchTopClick = this.onWatchTopClick.bind(this);
    }

    // todo: re-implement as Redux action creator
    _setSort(sortId) {
        this.props.dispatch({type: USER_SORTING_SELECT, sorting: sortId});
        this.close();
    }

    onWatchTopClick() {
        let {users, browser, currentUser, watcherCount, dispatch} = this.props;

        if (!currentUser.isAnonymous() && !currentUser.isXXL()) {
            this.close();
            BecomeXXLPopup.open("feature");
            
            return false;
        }

        let usersWatchers = [];
        let compareWatchers = (a, b) => a.count - b.count;

        users.forEach(user => typeof watcherCount[user.ufrag] !== 'undefined' && watcherCount[user.ufrag] > 1 ? 
            usersWatchers.push({
                ufrag: user.ufrag,
                count: watcherCount[user.ufrag]
            })
        : false);

        usersWatchers = usersWatchers.sort(compareWatchers).reverse();

        if(browser.desktop) usersWatchers = usersWatchers.slice(0, STREAM_LIMIT_DESKTOP).reverse();
        if(browser.tablet) usersWatchers = usersWatchers.slice(0, STREAM_LIMIT_TABLET);
        if(browser.mobile && !browser.tablet) usersWatchers = usersWatchers.slice(0, STREAM_LIMIT_MOBILE);

        if(usersWatchers.length) {
            for (let user of usersWatchers) {
                setTimeout(() => 
                    dispatch(openVideoWindow(user.ufrag)), 
                1000);
            }
        }

        this.close();
        dispatch({type: SIDEBAR_HIDE_ALL});
    }

    render() {
        let lang = Registry.get('locale');

        let {userSorting, browser} = this.props;

        let className = 'popup block-drop-sort ' + this.state.visibility;

        let countTopWatch = () => {
            if(browser.tablet) return STREAM_LIMIT_TABLET;
            if(browser.mobile) return STREAM_LIMIT_MOBILE;
            return STREAM_LIMIT_DESKTOP;
        };

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="watch-top" onClick={this.onWatchTopClick}>{lang.watch_top} {countTopWatch()}</div>
                <span>{lang.sort_by}</span>
                <ul>
                    <li><a href="#" className={userSorting === USER_SORT_ALPHA ? 'active' : ''} onClick={() => this._setSort(USER_SORT_ALPHA)}>{lang.sort_by_name}</a></li>
                    <li><a href="#" className={userSorting === USER_SORT_GENDER ? 'active' : ''} onClick={() => this._setSort(USER_SORT_GENDER)}>{lang.sort_by_gender}</a></li>
                    <li><a href="#" className={userSorting === USER_SORT_WATCHING ? 'active' : ''} onClick={() => this._setSort(USER_SORT_WATCHING)}>{lang.sort_by_watching}</a></li>
                    <li><a href="#" className={userSorting === USER_SORT_FOLLOWEES ? 'active' : ''} onClick={() => this._setSort(USER_SORT_FOLLOWEES)}>{lang.sort_by_followees}</a></li>
                    <li><a href="#" className={userSorting === USER_SORT_STATUS ? 'active' : ''} onClick={() => this._setSort(USER_SORT_STATUS)}>{lang.sort_by_status}</a></li>
                </ul>
            </div>

        )
    }

}

UserListSortPopup.generateKey = function(props) { return 'user-sort-popup' };
UserListSortPopup.mount = function(props) { return Popup.mount(UserListSortPopup, props) };

export default UserListSortPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserListSortPopup/index.js